import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';

interface IProps {
  customerId: string;
  accountId: string;
}

export const useGenerateRoutingNumberHook = ({ customerId, accountId }: IProps) => useMutation('payeeMigrationReport', async () => {
  const res = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/${accountId}/reports/payeeMigration`, {
    responseType: 'blob',
  });
  const contentDisposition = res.headers['content-disposition'];
  const filename = contentDisposition.split(';')[1];
  const firstSpliceIdx = filename.indexOf('"');
  const parsedName = filename.substring(firstSpliceIdx + 1, filename.length - 1);
  const IframeUrl = URL.createObjectURL(res.data);
  return { IframeUrl, parsedName };
});
